import { render } from "./CompletePayExpress.vue?vue&type=template&id=8970bf56"
import script from "./CompletePayExpress.vue?vue&type=script&lang=js"
export * from "./CompletePayExpress.vue?vue&type=script&lang=js"

import "./CompletePayExpress.vue?vue&type=style&index=0&id=8970bf56&lang=css"

import exportComponent from "C:\\Users\\btobia\\Documents\\ProyectosVSC\\marketvue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__